<script lang="ts">
  import { Card, CardBody, Col } from "sveltestrap";
</script>

<Col sm="12" lg="6" xl="4" md="12" class="xl-50 box-col-6">
  <Card class="height-equal">
    <div class="calender-widget">
      <div class="cal-img" />
      <div class="cal-date">
        <h5>25<br />Apr</h5>
      </div>
      <CardBody class="cal-desc text-center">
        <h6 class="f-w-600">I must explain to you how?</h6>
        <p>
          Denouncing pleasure and praising pain was born and I will give you a
          complete account of the system, and expound the actual teachings of
          the great explorer of the truth,Letraset sheets.
        </p>
      </CardBody>
    </div>
  </Card>
</Col>
